/*
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2022-03-16 14:48:52
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @LastEditTime: 2022-10-10 17:56:07
 * @FilePath: \dzCloud\src\plugins\filters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
// import config from "@/assets/js/config.js";
import dayjs from 'dayjs';
// const noImage = require("@/assets/images/no_image100x100.jpg");

var filter = {
    // 阿里相册前缀
    aliAlbumFormat(src, size) {
        // eslint-disable-next-line no-undef
        if (!src) {
            // eslint-disable-next-line no-undef
            return noImage;
        }
        if (size) {
            const match = src.match(/\.\w+$/);
            const ext = match && match.length ? match[0] : '';
            src = src.replace(/(\.\d+x\d+)?\.\w+$/, `.${size}${ext}`);
        }
        // eslint-disable-next-line no-undef
        return config.aliAlbumHost + src;
    },
    // 图片前缀
    imageFormat(src) {
        if (!src) {
            return '';
        }
        // eslint-disable-next-line no-undef
        return config.imgUrl + src;
    },
    imgFormat(url, size, isNeedHost = true) {
        if (size) {
            url = url.replace(/(.\w+$)/g, `.${size}x${size}$1`);
        }
        // eslint-disable-next-line no-undef
        return (isNeedHost ? config.alicdn : '') + url;
    },
    // 图片剪裁
    imageThumb(src, w, h) {
        if (!src) {
            return '';
        }
        const width = w || 272;
        const heigh = h || 438;
        return src + `?x-oss-process=image/resize,w_${width},image/crop,x_0,y_0,w_${width},h_${heigh}`;
    },
    // 提取时间戳 example:/Date(1558591720000)/
    timeStampFormat(str) {
        if (!str) {
            return '';
        }
        // let reg = /(?<=\/Date\().+(?=\)\/)/;
        const reg = /(\/Date\((\d+)\)\/)/;
        const match = str.match(reg);
        if (match && match.length >= 3) {
            return parseInt(match[2]);
        }
        return '';
    },
    // 格式化时间
    dateFormat(timestamp, format = 'YYYY-MM-DD HH:mm') {
        if (!timestamp) {
            return '';
        }
        const date = dayjs(timestamp);
        if (date.isValid()) {
            return date.format(format);
        }
        return '';
    },
    datetimeFormat: function (date, format) {
        date = filter.getDate(date);
        if (!date || date.toUTCString() === 'Invalid Date') {
            return '';
        }
        var map = {
            M: date.getMonth() + 1, // 月份
            d: date.getDate(), // 日
            h: date.getHours(), // 小时
            m: date.getMinutes(), // 分
            s: date.getSeconds(), // 秒
            q: Math.floor((date.getMonth() + 3) / 3), // 季度
            S: date.getMilliseconds(), // 毫秒
        };
        format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
            var v = map[t];

            if (v !== undefined) {
                if (all.length > 1) {
                    v = '0' + v;
                    v = v.substr(v.length - 2);
                }
                return v;
            } else if (t === 'y') {
                return (date.getFullYear() + '').substr(4 - all.length);
            }
            return all;
        });
        return format;
    },
    getDate: function (date) {
        if (typeof date === 'string') {
            var mts = date.match(/(\/Date\((\d+)\)\/)/);
            if (mts && mts.length >= 3) {
                date = parseInt(mts[2]);
            }
        }
        date = new Date(date);
        return date;
    },
};

for (var filteritem in filter) {
    Vue.filter(filteritem, filter[filteritem]);
}
